import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    Button,
    Box,
    Grid,
    Paper,
    Card,
    CardContent,
    CardActions
} from '@mui/material';
import AdminProducts from './AdminProducts';
import AdminReservations from './AdminReservations';
import AdminDates from './AdminDates';

const AdminDashboard: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Tableau de bord administrateur
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6">Produits</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Gérer les produits
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button onClick={() => navigate('/admin/products')} variant="contained">
                                Gérer
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6">Catégories</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Gérer les catégories
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button onClick={() => navigate('/admin/categories')} variant="contained">
                                Gérer
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6">Réservations</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Gérer les réservations
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button onClick={() => navigate('/admin/reservations')} variant="contained">
                                Gérer les réservations
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6">Planning</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Gérer les créneaux horaires
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button onClick={() => navigate('/admin/planning')} variant="contained">
                                Gérer le planning
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default AdminDashboard;